import React from 'react'
import { RouteComponentProps } from 'react-router'

import PageHeader from 'App/components/PageHeader'
import { useFeatureEnabled } from 'core/feature/hooks'
import { AutomatedMessagesClient } from './AutomatedMessagesClient'
import { AutomatedMessagesServerSide } from './AutomatedMessagesServerSide'

export const AutomatedMessages = (props: RouteComponentProps) => {
  const isAutomatedMessagesServerSideListEnabled = useFeatureEnabled('AutomatedMessagesServerSideList')

  return (
    <PageHeader title="Automated Messages" subTitle="View system generated messages sent">
      {isAutomatedMessagesServerSideListEnabled ? (
        <AutomatedMessagesServerSide {...props} />
      ) : (
        <AutomatedMessagesClient {...props} />
      )}
    </PageHeader>
  )
}

export default AutomatedMessages
